var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer flex items-center",on:{"click":_vm.goBack}},[_c('FontAwesomeIcon',{staticClass:"mr-2",attrs:{"icon":"chevron-left"}}),_c('span',[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }